import {
  parseStudentBillingConnectOnboardingSessionDto,
  parseStudentBillingPaymentAccountDto,
  type StudentBillingConnectOnboardingSessionDto,
  type StudentBillingPaymentAccountDto
} from "@madamuh/domain";
import { apiGet, apiPostWithHeaders } from "./client";

function root(tenantSlug: string): string {
  return `/api/v1/admin/tenants/${encodeURIComponent(tenantSlug)}/billing/payment-account`;
}

function headers(): Record<string, string> {
  return { "Idempotency-Key": crypto.randomUUID() };
}

export async function fetchStudentBillingPaymentAccount(tenantSlug: string): Promise<StudentBillingPaymentAccountDto> {
  return parseStudentBillingPaymentAccountDto(await apiGet<unknown>(root(tenantSlug)));
}

export async function createStudentBillingPaymentAccount(tenantSlug: string): Promise<StudentBillingPaymentAccountDto> {
  return parseStudentBillingPaymentAccountDto(await apiPostWithHeaders(root(tenantSlug), {}, headers()));
}

export async function createStudentBillingConnectOnboardingSession(tenantSlug: string): Promise<StudentBillingConnectOnboardingSessionDto> {
  return parseStudentBillingConnectOnboardingSessionDto(await apiPostWithHeaders(`${root(tenantSlug)}/onboarding-sessions`, {}, headers()));
}

export async function refreshStudentBillingPaymentAccount(tenantSlug: string): Promise<StudentBillingPaymentAccountDto> {
  return parseStudentBillingPaymentAccountDto(await apiPostWithHeaders(`${root(tenantSlug)}/refresh`, {}, headers()));
}
